import { combineReducers } from "redux";
import loggedReducer from "./login";

const rootReducers = combineReducers({
  login: loggedReducer,
});

export default rootReducers;
